import Call from '../../Call.v2';

const Countries = {
    get() {
        return Call(`dating/countries`);
    },

    save(countries) {
        return Call(`dating/countries`, 'POST', { countries });
    },
};

export default Countries;


// WEBPACK FOOTER //
// ./src/services/API/components/Dating/Countries.js